<template>
  <main id="main" class="main-site">
    <div class="container resposta">

        <h1>
          <strong>Obrigado!</strong>
        </h1>

        <span style="font-size: 16px;">Sua avaliação é muito importante para o nosso crescimento.</span>

        <div class="logo">
          <a :href="`${$SiteUrl}`" rel="nofollow" class="link">
            <img style="min-width:160px"  src="/assets/images/logo-top-aldo-solar.png" alt="Logo Aldo" title="Logo Aldo"/>

          </a>
          <button class="btn btn-primary" style="margin-top: 48px;" @click="redirectSite">Visite nosso site</button>
        </div>
    </div>
  </main>
</template>

<style type="text/css">
  .container.resposta {
    display: flex;
    flex-direction: column;
    margin: 50px auto;
    max-width: 600px
  }

  .container.resposta h1 {
    margin-bottom: 30px;
  }

  .container.resposta .logo {
    margin-top: 40px;
    justify-content: center;
    flex-direction: column;
    text-align: center;
  }

  .container.resposta .logo img {
    width: 350px;
    margin: 0 auto;
  }

  .container.resposta .logo .link {
    display: flex;
    flex-direction: column;
  }

  .container.resposta .btn-primary {
    padding: 10px 31px;
    border-radius: 4px;
    font-weight: 600;
    font-size: 12px;
    background-color: #0072A7;
  }

</style>

<script>
import axios from 'axios';

export default {
name: "CSATResposta",
  mounted() {

    const codigoPedido = this.$route.params.pedido;
    const score = this.$route.params.score;

    const body = {
      codigoPedido,
      score
    }

    axios.post(this.$apiUrl + "PedidosVenda.svc/csatpedido", body)
  },

  methods: {
    redirectSite: function() {
      window.location = this.$SiteUrl
    }
  }
};

</script>
